// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__P0DSH","right":"Footer_right__26llL","buttons":"Footer_buttons__1AVsa"};